import React, { useState, useEffect } from 'react';
import NavBar from '../_components/navbar';
import { connect, useDispatch } from 'react-redux';
import { animalAction, fazendaAction, logAction } from '../_actions';
import { withRouter } from '../_helpers/withRouter';
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonGroup, Container, Row, Col, FormGroup, Label, Input, Form, UncontrolledTooltip
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faCheck } from '@fortawesome/free-solid-svg-icons'
import { ModalLog } from '../log/';
import './styles.css';
import '././styles.css';

const AnimalEdit = (props) => {

    const dispatch = useDispatch();
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    useEffect(() => {
        const { match: { params } } = props;
        dispatch(fazendaAction.getFazenda());

        if (params.id) {
            dispatch(animalAction.getAnimalById(params.id, true));
        }

    }, []);

    const handleChange = prop => event => {
        dispatch(animalAction.onChangeProps(prop, event));
    };

    const handleClick = prop => event => {

        const { match: { params } } = props;
        const { dispatch } = props;

        if (this.props.animal.data === null || props.animal.data === '') {
            alert('Informe uma Data válida!');
        } else if (this.props.animal.id_fazenda === null || props.animal.id_fazenda === '') {
            alert('Informe uma Fazenda válida!');
        } else if (this.props.animal.id_touro === null || props.animal.id_touro === '') {
            alert('Informe um Touro válido!');
        } else {

            let payload = {
                id: params.id,
                id_animal: props.animal.id_animal,
                id_fazenda: props.animal.id_fazenda,
            }

            if (params.id) {
                dispatch(animalAction.editAnimalInfo(params.id, payload));
            } else {
                dispatch(animalAction.createAnimal(payload));
            }

        }

    };

    const handleClickHistory = event => {

        event.preventDefault();
        const { match: { params } } = props;
        const { dispatch } = props;

        if (params.id) {
            dispatch(logAction.getLog('Animal', params.id));
            toggle();
        }

    };

    const renderOptionsFazenda = () => {

        const { match: { params } } = props;

        return props.fazenda.fazenda.map((p, i) => {
            return (
                <option
                    value={p.id}
                    selected={p.id == props.animal.id_fazenda ? true : false}
                    key={i} name={p.nome}>{p.nome}
                </option>

            );
        });
    };

    //renderOptionsAnimal() {
    //    return this.props.animal.animal.map((p, i) => {
    //        return (
    //            <option
    //                value={p.id}
    //                selected={p.value == this.props.animal.id_animal ? "true" : "false"}
    //                key={i} name={p.Text}>{p.Text}
    //            </option>

    //        );
    //    });
    //};

    //renderOptionsTouro() {
    //    return this.props.touro.touro.map((p, i) => {
    //        return (
    //            <option
    //                value={parseInt(p.Value)}
    //                selected={p.value == this.props.animal.tipo ? "true" : "false"}
    //                key={i} name={p.Text}>{p.Text}
    //            </option>

    //        );
    //    });
    //};

    const { log } = props.log;

    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/animais">Lista de Animais</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Brinco {props.animal.brinco}</BreadcrumbItem>
                                    <BreadcrumbItem className="pb-0 pt-0 m-0 btn btn-muted">
                                        <a href="#" id="tagHistorico" onClick={(event) => handleClickHistory(event)}>Histórico</a>
                                        <UncontrolledTooltip placement="bottom" target="tagHistorico">
                                            Exibe o histórico de alterações do registro
                                        </UncontrolledTooltip>
                                    </BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="data_nascimento">Data Nascimento</Label>
                                        <Input
                                            id="data_nascimento"
                                            label="Data Nascimento"
                                            className="form-control"
                                            type="datetime-local"
                                            readOnly
                                            onChange={handleChange('data_nascimento')}
                                            value={props.animal.data_nascimento}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label className="left" for="id_fazenda">Fazenda *</Label>
                                        <Input
                                            name="id_fazenda"
                                            type="select"
                                            onChange={handleChange('id_fazenda')}
                                            value={props.fazenda.id_fazenda}
                                            className="form-control"
                                            readOnly
                                        >
                                            {renderOptionsFazenda()}
                                        </Input>
                                        {/*<FormHelperText>Label + placeholder</FormHelperText>*/}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label className="left" for="brinco">Brinco *</Label>
                                        <Input
                                            name="brinco"
                                            onChange={handleChange('brinco')}
                                            value={props.animal.brinco}
                                            className="form-control"
                                            readOnly />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <ButtonGroup>
                                        <Button variant="contained" color="secondary" component='a' href="/animais">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                        {props.animal.id ? null : <Button variant="contained" color="primary" onClick={(event) => handleClick(event)}>Salvar <FontAwesomeIcon icon={faCheck} /></Button>}
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>
            <ModalLog toggle={toggle} modal={modal} log={log} />
        </div>
    );

};


const mapStateToProps = (state) => {
    return state;
}

const connectedAnimalEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(AnimalEdit));

export { connectedAnimalEditPage as AnimalEdit };